import { render, staticRenderFns } from "./BriqMultilanguage.vue?vue&type=template&id=2ce6b89c&scoped=true&lang=pug&"
import script from "./BriqMultilanguage.vue?vue&type=script&lang=js&"
export * from "./BriqMultilanguage.vue?vue&type=script&lang=js&"
import style0 from "./BriqMultilanguage.vue?vue&type=style&index=0&id=2ce6b89c&scoped=true&lang=stylus&"
import style1 from "./BriqMultilanguage.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6b89c",
  null
  
)

export default component.exports